module.exports = __webpack_public_path__ + "img/plan-changed-bg.fa29649f.svg";